import useSelector from '@app/hooks/useSelector';

import { getFileFormats } from '../../reducers/downloadData/selectors';
import type { FileFormat, FileFormats } from '../../types';
import FileFormatInput from './FileFormatInput';
import type { Options } from './types';

export const prepareOptions = (fileFormats: FileFormats): Options =>
    fileFormats.map(({ group, formats }) => ({
        label: group,
        options: formats.map(({ value, label }) => ({ value, label })),
    }));

const getOptionByValue = (options: Options, value: FileFormat) =>
    options.flatMap((item) => item.options).find((item) => item.value === value);

interface FileFormatInputContainerProps {
    value: FileFormat;
    onChange: (value: FileFormat) => void;
}

const FileFormatInputContainer = ({ value, onChange }: FileFormatInputContainerProps) => {
    const fileFormats = useSelector(getFileFormats);
    const options = prepareOptions(fileFormats);

    return (
        <FileFormatInput
            value={getOptionByValue(options, value)}
            options={options}
            onChange={(item) => onChange(item.value)}
        />
    );
};

export default FileFormatInputContainer;
